var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { Country } from 'packages/target/entities/Country';
import { Region } from 'packages/target/entities/Region';
var City = /** @class */ (function (_super) {
    __extends(City, _super);
    function City() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.name = null;
        _this.radius = 45;
        _this.country = new Country();
        _this.region = new Region();
        return _this;
    }
    Object.defineProperty(City.prototype, "nameWithRegion", {
        get: function () {
            var _a;
            return ((_a = this.region) === null || _a === void 0 ? void 0 : _a.id) ? this.name + ", " + this.region.name : this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(City.prototype, "fullName", {
        get: function () {
            var _a;
            return ((_a = this.region) === null || _a === void 0 ? void 0 : _a.id)
                ? this.name + ", " + this.country.name + " (" + this.region.name + ")"
                : this.name + ", " + this.country.name;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Type(Country),
        __metadata("design:type", Object)
    ], City.prototype, "country", void 0);
    __decorate([
        Type(Region),
        __metadata("design:type", Object)
    ], City.prototype, "region", void 0);
    return City;
}(Entity));
export { City };
